import styled from 'styled-components';

export const Spinner = styled.div<{ size: number }>`
  position: relative;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  display: inline-block;
`;

export const SvgRing = styled.svg<{ size: number }>`
  transform: rotate(-90deg); // Start at top center
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  position: absolute;
  top: 0;
  left: 0;
`;
